export * from './curriculum-browse.component';